<template>
    <!-- 订单管理-票券预约记录 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'ticketReservationRecord')">
        <div slot="header">
            <a-form :form="form" layout="inline" :hideRequiredMark="true">
            <a-form-item label="用户票券id">
                <a-input placeholder="请输入" v-decorator="['reserveObject']" @pressEnter="search(false)"></a-input>
            </a-form-item>
            <a-form-item label="票券名称">
                <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search(false)"></a-input>
            </a-form-item>
            <a-form-item label="手机号">
                <a-input placeholder="请输入" v-decorator="['phone']" @pressEnter="search(false)"></a-input>
            </a-form-item>
            <a-form-item label="预约状态">
                <a-select allowClear placeholder="请选择" v-decorator="['state']" @select="search(false)">
                    <a-select-option value="1">已预约</a-select-option>
                    <a-select-option value="2">预约取消</a-select-option>
                    <a-select-option value="3">已核销</a-select-option>
                    <a-select-option value="4">预约过期</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="购买途径">
                <a-select allowClear placeholder="请选择" v-decorator="['platform']" @select="search(false)">
                    <template v-for="(item,index) in $utils.platform">
                        <a-select-option :key="index" :value="index" v-if="item">{{item}}</a-select-option>
                    </template>
                </a-select>
            </a-form-item>
            <a-form-item label="购买门店">
                <a-select allowClear placeholder="请选择" v-decorator="['shopId']" @select="search(false)">
                    <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="预约使用门店">
                <a-select allowClear placeholder="请选择" v-decorator="['reserveShopId']" @select="search(false)">
                    <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="预约下单时间">
                <a-range-picker
                    style="width:282px"
                    format="YYYY/MM/DD"
                    v-decorator="['orderDate']"
                    @change="search(false)"
                />
            </a-form-item>
            <a-form-item label="预约使用时间">
                <a-range-picker
                    style="width:282px"
                    format="YYYY/MM/DD"
                    v-decorator="['reserveDate']"
                    @change="search(false)"
                />
            </a-form-item>
            <a-form-item class="wrap-header-button">
                <a-button @click="search(false)" class="mr8" type="primary" :loading="loading">筛选</a-button>
                <a-button @click="handleReset">重置</a-button>
            </a-form-item>
            </a-form>
        </div>
        <div class="wrap-container-in">
            <div class="mb16" v-if="getBtnByAuth('ticketReservationExport')">
                <a-button type="primary" @click="search(true)" :loading="loading">导出excel</a-button>
                <a-button @click="openExportModal">导出记录</a-button>
            </div>
            <a-table :scroll="{y: 620}" style="word-break:break-all;" :loading="loading" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                <span slot="state" slot-scope="state,row">{{['','已预约','预约取消','已核销','预约过期','次数退还'+row.returnNum+'次'][state]}}</span>
                <span slot="orderNum" slot-scope="orderNum">{{orderNum || 1}}</span>
                <span slot="buyShopName" slot-scope="buyShopName">{{buyShopName || "-"}}</span>]
                <span slot="reserveShopName" slot-scope="reserveShopName">{{reserveShopName || "-"}}</span>
                <span slot="platform" slot-scope="platform, row">{{!platform ? "-" : platform == "收银台" ? row.shopName : platform}}</span>
                <span slot="reserveDate" slot-scope="reserveDate, row">{{row.periodStartTime | dateSplit}} ~ {{row.periodEndTime | dateSplit}}</span>
                <span slot="createTime" slot-scope="createTime, row">{{row.createTime}}</span>
                <span slot="reservePeriod" slot-scope="key, row">{{row.periodStartTime.substring(11, 16)}}~{{row.periodEndTime.substring(11, 16)}}</span>
                <span slot="sponsor" slot-scope="sponsor, row">{{row.phone || row.suppleStaffName || "-"}}</span>
                <span v-if="getBtnByAuth('ticketReservationCancel')" slot="action" slot-scope="text, row">
                    <a @click="openModal(row)" v-if="row.state == 1 || row.state == 4" class="text-primary">预约取消</a>
                    <a v-else class="text-disabled">预约取消</a>
                </span>
            </a-table>
            <a-modal 
            centered
            title="取消预约"
            :visible="visible"
            @cancel="closeModal"
            @ok="cancelReserve"
            :width="500">
                <a-form :form="cancelForm">
                    <remark :labelSpan="5" :wrapperSpan="18" operateCode="CancelReserve" ></remark>
                </a-form>
            </a-modal>
        </div>
        <report-export-modal ref="reportExportModal" :exportType="2"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    const columns = [
    {
        title: "用户票券id",
        dataIndex: "reserveObject"
    },
    {
        title: "票券名称",
        dataIndex: "name"
    },
    {
        title: "会员手机号",
        dataIndex: "phone",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "购买途径",
        dataIndex: "platform",
        scopedSlots: { customRender: "platform" }
    },
    {
        title: "预约使用门店",
        dataIndex: "reserveShopName",
        scopedSlots: { customRender: "reserveShopName" }
    },
    {
        title: "预约状态",
        dataIndex: "state",
        scopedSlots: { customRender: "state" }
    },
    {
        title: "预约次数",
        dataIndex: "orderNum",
        scopedSlots: { customRender: "orderNum" }
    },
    {
        title: "预约下单时间",
        dataIndex: "reserveTime",
        scopedSlots: { customRender: "reserveTime" }
    },
    {
        title: "预约使用日期",
        dataIndex: "reserveDate",
        scopedSlots: { customRender: "reserveDate" }
    },
    {
        title: "预约场次",
        dataIndex: "reservePeriod",
        scopedSlots: { customRender: "reservePeriod" }
    },
    {
        title: "预约发起人",
        dataIndex: "sponsor",
        scopedSlots: { customRender: "sponsor" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }]
    import moment from 'moment';
    import remark from '@/components/modules/platform/remark.component';
    export default {
        name: "ticketReservationRecord",
        components: {
            remark
        },
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                shopList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                visible: false,
                currentRow: {},
            };
        },
        computed: {
            'maxNum'() {
                // 当未核销时，可退还最多次数为预约次数；当核销后，可退还最多次数为实际核销次数
                // 实际核销次数可能会大于预约次数，因为有强制核销
                // appointmentUsage 预约次数
                // actualUsage 实际使用次数
                // return this.currentRow.actualUsage ? (this.currentRow.appointmentUsage < this.currentRow.actualUsage ? 0 : this.currentRow.appointmentUsage - this.currentRow.actualUsage) : this.currentRow.appointmentUsage
                // 方案二 
                return this.currentRow.actualUsage > 0 ? this.currentRow.actualUsage : this.currentRow.appointmentUsage
            }
        },
        filters: {
            dateSplit(val) {
                if (!val) return "";
                return val.substring(0, 10);
            }
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.pagination.pageSize = 20
                this.pagination.current = 1
                this.form.resetFields();
                this.getList(false);
            },
            search(isExport) {
                this.pagination.current = 1;
                this.getList(isExport);
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    this.shopList = res;
                    this.getList();
                });
            },
            // 获取使用订单列表
            getList(isExport) {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const orderDate = values['orderDate'] ? values['orderDate'] : []
                    values.createStartTime = orderDate.length > 0 ? orderDate[0].format('YYYY-MM-DD') : undefined
                    values.createEndTime = orderDate.length > 0 ? orderDate[1].format('YYYY-MM-DD') : undefined

                    const reserveDate = values['reserveDate'] ? values['reserveDate'] : []
                    values.useStartTime = reserveDate.length > 0 ? reserveDate[0].format('YYYY-MM-DD') : undefined
                    values.useEndTime = reserveDate.length > 0 ? reserveDate[1].format('YYYY-MM-DD') : undefined

                    delete values.orderDate
                    delete values.reserveDate
                    this.loading = true;
                    this.$api.order.getTicketOrderList({
                        query: Object.assign(values, 
                        {   
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                        })
                    }).then(res => {
                        this.loading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                        if (Boolean(isExport)) {
                            this.exportExcel();
                        }
                    }).catch(err => {
                        this.loading = false;
                    })
                });
            },

            // 导出excel
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const orderDate = values['orderDate'] ? values['orderDate'] : []
                    values.createStartTime = orderDate.length > 0 ? orderDate[0].format('YYYY-MM-DD') : undefined
                    values.createEndTime = orderDate.length > 0 ? orderDate[1].format('YYYY-MM-DD') : undefined

                    const reserveDate = values['reserveDate'] ? values['reserveDate'] : []
                    values.useStartTime = reserveDate.length > 0 ? reserveDate[0].format('YYYY-MM-DD') : undefined
                    values.useEndTime = reserveDate.length > 0 ? reserveDate[1].format('YYYY-MM-DD') : undefined

                    delete values.reserveDate;
                    delete values.orderDate;
                    this.loading = true;
                    this.$api.order.ticketOrderExport({
                        query: Object.assign(values, 
                        {   
                            pageNum: 1,
                            pageSize: this.pagination.total
                        })
                    },)
                    .then(res => {
                        this.openExportModal();
                        this.loading = false;
                    }).catch( err => {
                        this.loading = false
                    })
                });
            },
            // 取消预约
            cancelReserve() {
                this.cancelForm.validateFields((err, values) => {
                    if (err) return;
                    this.$api.order.cancelReserve({
                        body: {reserveId: this.currentRow.id, ...values}
                    })
                    .then(res => {
                        this.visible = false;
                        this.$message.success('操作成功',2)
                        setTimeout(() => {
                            this.getList();
                        }, 500);
                    })
                })
                
            },
            openModal(row) {
                this.visible = true
                this.cancelForm.resetFields();
                this.currentRow = row
            },
            closeModal() {
                this.visible = false
                setTimeout(() => {
                    this.getList()
                }, 500);
                
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            }
        },
        beforeCreate() {
            this.cancelForm = this.$form.createForm(this);
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getShopList();
        }
    };
</script>
<style lang="scss">
</style>